var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyBottomChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13267_1878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02637 2.00195C0.724946 1.72669 0.723485 1.27094 1.02734 0.99707C1.31902 0.734567 1.78648 0.734861 2.0791 0.996094L2.08008 0.99707L5.99902 4.52246L9.91699 0.99707C10.2092 0.734051 10.676 0.735362 10.9707 0.995117L11.0254 1.0498C11.2754 1.32663 11.2558 1.74275 10.9736 2.00195L10.9727 2.00293L6.52734 6.00293C6.38235 6.13335 6.19407 6.2002 6 6.2002C5.80593 6.2002 5.61765 6.13335 5.47266 6.00293L1.02734 2.00293L1.02637 2.00195Z",
    fill: "#BABEC1",
    stroke: "#BABEC1",
    strokeWidth: 0.4,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13267_1878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 7,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyBottomChevron);
export default __webpack_public_path__ + "static/media/grey-bottom-chevron.cb460267b890165d2364b6a55cb0e9de.svg";
export { ForwardRef as ReactComponent };